import { createEmIcon } from '../designSystemIcons';

export const SignatureInitialIcon = createEmIcon('pencil');
